import React from 'react';
import styled from 'styled-components';

import { MessageBubble, Typography } from '../../designComponents';

const ServiceHeroStyled = styled.div`
  margin: 0px 30px 80px;
  position: relative;
  min-height: 40vh;
  padding: 100px 0px 120px;

  & .content-container {
    position: relative;
    max-width: 760px;
    margin: 0 auto;
    width: 100%;
    z-index: 100;

    & .title {
      font-size: 32px;
      line-height: 50px;
      margin-bottom: 20px;
      font-weight: 600;
    }
    & .desc {
      font-size: 16px;
      line-height: 28px;
      font-weight: 500;
    }
  }

  @media (max-width: 800px) {
    padding-top: 120px;
    margin: 0px 20px 80px;

    & .content-container {
      & .title {
        font-size: 30px;
        line-height: 45px;
      }
    }
  }

  @media (max-width: 500px) {
    padding-bottom: 150px;
    & .content-container {
      & .title {
        font-size: 18px;
        line-height: 32px;
      }
      & .desc {
        font-size: 14px;
        line-height: 25px;
      }
    }
  }

  & .color-text {
    color: ${({ theme }) => theme.colors.primary};
  }
`;

const ServiceHero = () => {
  return (
    <ServiceHeroStyled>
      <MessageBubble
        isReceived
        message="Tips for “How to generate a drawing of builing? “"
        position="absolute"
        placement={{ top: '0px', left: '0px' }}
      />
      <MessageBubble
        message='"A discrepancy in the evacuation plan has been flagged by a professional."'
        position="absolute"
        placement={{ top: '20px', right: '0px' }}
      />
      <MessageBubble
        isReceived
        message="New Ext symbol added by admin."
        position="absolute"
        placement={{ bottom: '0px', left: '0px' }}
      />
      <MessageBubble
        message='"A discrepancy in the evacuation plan has been flagged by a professional."'
        position="absolute"
        placement={{ bottom: '40px', right: '0px' }}
      />
      <div className="content-container">
        <Typography className="title">
          Empowering You with Effective&nbsp;
          <span className="color-text">Escape Planning Strategies</span>
          &nbsp;and <span className="color-text">Tools</span>
        </Typography>
        <Typography className="desc">
          In our services section, we provide a wide array of comprehensive
          solutions designed to enhance building safety and emergency
          preparedness. From detailed escape planning strategies to intuitive
          tools and expert guidance, we are dedicated to empowering you with
          everything you need to ensure the safety and well-being of occupants
          during emergencies. Explore our range of services below and discover
          how we can help you create a safer environment for all.
        </Typography>
      </div>
    </ServiceHeroStyled>
  );
};

export default ServiceHero;
